<template>
  <i v-if="isRelevant" class="tm-audio-wave" :class="classObj">
    <canvas
      ref="display"
      class="-display"
      :style="{ width: `${$data.canvasWidth}px` }"
    />
  </i>
</template>

<script>
import gridMixin from 'v/Story/Timeline/view/grid.mixin';
import timemachineTaskManager from 'v/Story/Timeline/api/timemachineTaskManager';
import fg from '#/libs/FrameGrid';
import { mapState } from 'vuex';
import { serialInvocation } from '#/worker/toolkit';

export default {
  name: 'tm-audio-wave',
  mixins: [gridMixin],

  data() {
    return {
      canvasWidth: 0,
      renderPayload: null,
      isRendering: false,
      lastRenderRequested: 0,
    };
  },

  props: {
    track: { type: Object, required: true },
    rectangle: { type: Object, required: true },
    isFirst: { type: Boolean, required: true },
    isLast: { type: Boolean, required: true },
    isSelected: { type: Boolean, required: true },
    isMoving: { type: Boolean, required: true },
    hasAudioWaveForm: { type: Boolean, required: true },
  },

  computed: {
    ...mapState('timemachine', {
      pxAudioTrackH: (state) => state.cssVariables.pxAudioTrackH,
      MODE_AUDIO_DND: (state) => state.MODE.AUDIO_DND,
      MODE_AUDIO_RESIZE: (state) => state.MODE.AUDIO_RESIZE,
    }),

    isRelevant() {
      // NOTE: this is an experiment
      // return this.gridEstablished && !this.$props.isMoving && this.$props.hasAudioWaveForm;
      return this.gridEstablished && this.$props.hasAudioWaveForm;
      // return this.gridEstablished && this.$props.hasAudioWaveForm;
    },

    classObj() {
      const alignRight =
        (this.MODE_AUDIO_DND && !this.$props.isFirst && this.$props.isLast) ||
        (this.MODE_AUDIO_RESIZE && this.$props.track.resizeEscort.fromLeft);

      return {
        '-align-right': alignRight,
      };
    },

    localStartTime() {
      return fg.trunc(
        this.$props.track.data.relativeStartTime +
          this.$props.rectangle.startTime -
          this.$props.track.data.displayStartTime
      );
    },

    localEndTime() {
      return fg.trunc(
        this.$props.track.data.relativeStartTime +
          this.$props.rectangle.endTime -
          this.$props.track.data.displayStartTime
      );
    },

    drawDependency() {
      return `${this.isSelected ? 1 : 0}${this.localStartTime}${
        this.localEndTime
      }${this.isRelevant ? 1 : 0}`;
    },
  },

  created() {
    this.$_displayWaveform = serialInvocation(
      this.$_displayWaveformTarget,
      this.$_drawBitmap
    );
  },

  watch: {
    drawDependency: {
      deep: false,
      immediate: true,
      handler: '$_drawIfNeeded',
    },
  },

  methods: {
    $_drawIfNeeded() {
      if (!this._isDestroyed && this.isRelevant && window.OffscreenCanvas) {
        if (this.$refs.display && this.$_displayWaveform) {
          this.$_displayWaveform();
        } else {
          this.$nextTick(this.$_drawIfNeeded);
        }
      }
    },

    $_drawBitmap({ bitmap, width }) {
      if (!this._isDestroyed && this.$refs.display) {
        const canvas = this.$refs.display;
        const bitmapContext = canvas.getContext('bitmaprenderer');
        bitmapContext.transferFromImageBitmap(bitmap);
        this.$data.canvasWidth = width;
      }
    },

    $_displayWaveformTarget() {
      return timemachineTaskManager.renderWaveform({
        waveformSourceId: this.$props.track.data.metadata.assetUUID,
        width: this.$props.rectangle.width,
        height: this.pxAudioTrackH,
        startTime: this.localStartTime,
        endTime: this.localEndTime,
        style: {
          factor: window.devicePixelRatio ?? 1,
          lineWidth: 1,
          background: 'white',
          sampleColour: this.isSelected ? '#06A9F4' : 'rgba(6,169,244, 0.5)',
        },
      });
    },
  },
};
</script>

<style lang="scss">
.tm-audio-span > .tm-audio-wave {
  position: absolute;
  pointer-events: none;
  overflow: hidden;

  &.-align-right > .-display {
    right: 0;
    position: absolute;
  }

  > .-display {
    height: var(--tm-pxAudioTrackH);
  }
}
</style>
